import { useTheme } from '../context/ThemeContext';
import { Link } from 'react-router-dom';

const SECTIONS = [
  {
    title: '1. Общие положения',
    content: `Настоящая Политика конфиденциальности (далее — Политика) определяет порядок обработки персональных данных пользователей сервиса MolShape (далее — Сервис, Оператор).

Оператор обрабатывает персональные данные в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных», иными нормативными правовыми актами Российской Федерации в области защиты персональных данных.

Использование Сервиса означает безоговорочное согласие пользователя с настоящей Политикой и указанными в ней условиями обработки его персональных данных.`,
  },
  {
    title: '2. Оператор персональных данных',
    content: `Оператором персональных данных является: MolShape (тренер Молчанова Алёна).
Telegram: @molchanova_fit
По всем вопросам обработки персональных данных обращайтесь через Telegram.`,
  },
  {
    title: '3. Состав обрабатываемых персональных данных',
    content: `Оператор обрабатывает следующие персональные данные:
• Имя и фамилия пользователя
• Номер телефона (при указании)
• Telegram ID и имя пользователя Telegram
• Дата рождения
• Пол
• Рост
• Антропометрические замеры: вес, обхват груди, бицепса, талии, живота, бёдер, бедра, голени, над коленом
• Цели и уровень физической активности
• Стаж и частота тренировок
• Заметки тренера`,
  },
  {
    title: '4. Цели обработки персональных данных',
    content: `Персональные данные обрабатываются в следующих целях:
• Регистрация и авторизация пользователя в Сервисе
• Расчёт показателей здоровья: ИМТ, процента жира, КБЖУ, WHR и других
• Отображение динамики антропометрических показателей пользователя
• Предоставление тренеру доступа к данным подопечного для оказания услуг
• Направление уведомлений через мессенджер Telegram
• Выгрузка отчётов по запросу тренера`,
  },
  {
    title: '5. Правовые основания обработки',
    content: `Обработка персональных данных осуществляется на основании:
• Согласия субъекта персональных данных (ст. 6, ч. 1, п. 1; ст. 9 Федерального закона № 152-ФЗ)
• Необходимости исполнения договора об оказании фитнес-услуг, стороной которого является субъект персональных данных (ст. 6, ч. 1, п. 5 Федерального закона № 152-ФЗ)`,
  },
  {
    title: '6. Порядок и условия обработки',
    content: `Обработка персональных данных осуществляется с использованием средств автоматизации.
Персональные данные хранятся на защищённых серверах на территории Европейского союза (Финляндия).
Передача персональных данных третьим лицам не осуществляется, за исключением случаев, предусмотренных законодательством Российской Федерации.
Оператор принимает необходимые организационные и технические меры для защиты персональных данных от неправомерного доступа, уничтожения, изменения, блокирования, копирования, распространения.`,
  },
  {
    title: '7. Сроки хранения персональных данных',
    content: `Персональные данные хранятся в течение всего срока использования Сервиса пользователем.
После отзыва согласия или прекращения использования Сервиса персональные данные удаляются в течение 30 календарных дней на основании письменного обращения субъекта персональных данных, направленного тренеру через Telegram: @molchanova_fit`,
  },
  {
    title: '8. Права субъектов персональных данных',
    content: `В соответствии с Федеральным законом № 152-ФЗ пользователь вправе:
• Получить информацию об обработке своих персональных данных
• Требовать уточнения, блокирования или уничтожения персональных данных
• Отозвать согласие на обработку персональных данных
• Обжаловать действия Оператора в уполномоченный орган по защите прав субъектов персональных данных (Роскомнадзор)

Для реализации прав обращайтесь: @molchanova_fit`,
  },
  {
    title: '9. Cookies и технические данные',
    content: `Сервис использует локальное хранилище браузера (localStorage) исключительно для хранения токена авторизации и пользовательских настроек (цветовая тема, тёмный режим).
Данные из localStorage не передаются третьим лицам и не используются в рекламных целях.`,
  },
  {
    title: '10. Изменение политики',
    content: `Оператор вправе вносить изменения в настоящую Политику. Новая редакция вступает в силу с момента публикации на сайте. Продолжение использования Сервиса после изменений означает согласие с новой редакцией Политики.

Дата последнего обновления: июнь 2026 г.`,
  },
];

export default function PrivacyPolicy() {
  const { isDark, theme } = useTheme();
  const bg   = isDark ? '#0E0B18' : '#F9F6FF';
  const card = isDark ? '#1A1526' : '#FFFFFF';
  const bdr  = isDark ? 'rgba(255,255,255,.07)' : 'rgba(0,0,0,.06)';
  const txt  = isDark ? '#F2EEF9' : '#2D1B35';
  const mut  = isDark ? 'rgba(200,185,220,.65)' : 'rgba(80,60,100,.6)';
  const acc  = theme.accent;

  return (
    <div style={{ maxWidth:700, margin:'0 auto', padding:'2rem 1rem', fontFamily:'Inter,system-ui,sans-serif' }}>
      <Link to="/dashboard" style={{ color:acc, textDecoration:'none', fontSize:'.875rem', display:'inline-flex', alignItems:'center', gap:6, marginBottom:24 }}>
        ← Назад
      </Link>

      <div style={{ background:card, border:`1px solid ${bdr}`, borderRadius:20, padding:'2rem',
                    boxShadow:isDark?'0 4px 24px rgba(0,0,0,.4)':'0 4px 24px rgba(100,60,140,.08)' }}>

        <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${bdr}` }}>
          <div style={{ width:44, height:44, borderRadius:12, background:theme.grad, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, boxShadow:`0 4px 14px ${theme.glow}` }}>
            <span style={{ color:'#fff', fontWeight:900, fontSize:14, fontFamily:'Nunito,system-ui' }}>MS</span>
          </div>
          <div>
            <h1 style={{ color:txt, fontFamily:'Nunito,system-ui', fontWeight:800, fontSize:'1.4rem', margin:0 }}>
              Политика конфиденциальности
            </h1>
            <p style={{ color:mut, fontSize:'.75rem', margin:'3px 0 0' }}>MolShape · Федеральный закон № 152-ФЗ</p>
          </div>
        </div>

        <div style={{ display:'flex', flexDirection:'column', gap:24 }}>
          {SECTIONS.map((s, i) => (
            <div key={i}>
              <h2 style={{ color:acc, fontFamily:'Nunito,system-ui', fontWeight:700, fontSize:'1rem', margin:'0 0 10px' }}>
                {s.title}
              </h2>
              <div style={{ color:mut, fontSize:'.875rem', lineHeight:1.75, whiteSpace:'pre-line' }}>
                {s.content}
              </div>
            </div>
          ))}
        </div>

        <div style={{ marginTop:28, paddingTop:20, borderTop:`1px solid ${bdr}`, textAlign:'center' }}>
          <p style={{ color:mut, fontSize:'.78rem', margin:0 }}>
            По вопросам обработки персональных данных:{' '}
            <a href="https://t.me/molchanova_fit" target="_blank" rel="noreferrer" style={{ color:acc }}>
              @molchanova_fit
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
